/* eslint-disable local-rules/require-use-client */
import { Listbox, ListboxButton, ListboxOption, ListboxOptions } from '@headlessui/react'
import { CheckIcon, ChevronUpDownIcon } from '@heroicons/react/20/solid'

import { getBuilderPreviewMode } from '@src/utils/builder.util'
import { cn } from '@src/utils/tailwind'

import type { SKUSelectorV2DropdownOption } from './SKUSelectorV2Props'

export interface SKUSelectorV2DropdownProps {
  dropdownOptions: SKUSelectorV2DropdownOption[] | undefined
  activeOption: SKUSelectorV2DropdownOption | undefined
  selectedSku: string
  isLoading: boolean
  onChange: (sku: string) => void
  previewAllItems?: boolean
}

export function SKUSelectorV2Dropdown({
  dropdownOptions,
  activeOption,
  selectedSku,
  isLoading,
  onChange,
  previewAllItems = false,
}: SKUSelectorV2DropdownProps) {
  const isPreview = previewAllItems && getBuilderPreviewMode().edit

  if (isPreview) {
    return (
      <div className="flex flex-col gap-4 border border-blue-400 px-4">
        {dropdownOptions?.map((option) => (
          <div
            className="flex flex-col gap-8 border-b border-bodi-gray-butters py-4 last:border-b-0"
            key={option.sku}
          >
            {option.contentTop}
            {option.content}
          </div>
        ))}
      </div>
    )
  }

  return (
    <div className="flex w-full flex-col">
      {activeOption?.contentTop}
      <Listbox value={selectedSku} onChange={onChange} disabled={isLoading}>
        <ListboxButton className="flex w-full items-center justify-between rounded-lg p-4 text-left outline outline-1 outline-bodi-gray-butters">
          {activeOption?.content}
          <ChevronUpDownIcon className="size-4" />
        </ListboxButton>
        <ListboxOptions
          anchor="bottom"
          transition
          className={cn(
            'mt-2 w-(--button-width) origin-top rounded-lg bg-bodi-white py-2 outline outline-1 outline-bodi-gray-butters drop-shadow-md',
            'transition duration-200 ease-out data-closed:scale-95 data-closed:opacity-0'
          )}
        >
          {dropdownOptions?.map((option) => (
            <ListboxOption
              key={option.sku}
              value={option.sku}
              className="flex items-center gap-2 p-3 text-left hover:bg-bodi-green-bright-300"
            >
              <CheckIcon
                className={cn(
                  'size-5 text-transparent',
                  option.sku === selectedSku && 'text-bodi-green-deep-500'
                )}
              />
              {option.content}
            </ListboxOption>
          ))}
        </ListboxOptions>
      </Listbox>
    </div>
  )
}
